import * as actionTypes from '../actions/actionTypes';

const initState = {};

export default function inFlightCasesStateReducer(state = initState, action) {
  switch(action.type){
    case actionTypes.SET_INFLIGHT_CASES_STATE_FOR_ENTITY: {
      const {entityId, inFlightState} = action;
      let newState = {...state, [entityId]: {
        ...state[entityId],
        ...inFlightState
      }};
      return newState
    }
    case actionTypes.CLEAR_INFLIGHT_CASES_STATE_FOR_ALL_ENTITIES: {
      return {};
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ViewEntityProfile/reducers/inFlightCasesStateReducer.js